define('controllers/modules/template/template',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // parent
    'src/controller/controller',
    // models
    'models/template/assignment',
    'models/template/template',
    'collections/template/assignments',
    'collections/member/supervisors',
    // views
    'views/modules/template/assignment/assignment-panel',
    'views/modules/template/assignment/manager/per-user/per-user-manager-panel',
    'views/modules/template/edit/template'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // parent
    Controller,
    // models
    MTemplateAssignment,
    MTemplate,
    CTemplateAssignments,
    Supervisors,
    // views
    VTemplateAssignmentPanel,
    VPerUserAssignmentManagerPanel,
    VTemplate
) {

    var TemplateCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*template': 'index',
            ':templateId(/)': 'editRoute',
            'assign(/)': 'assignRoute',
            'manage(/)': 'manageRoute',
            ':templateId(/)assignment(/)': 'assignmentRoute',
        },

        subRoutes: {
            template: '{{{templateId}}}',
        },

        initialize: function(prefix, opt) {
            _.extend(this, {
                view: {},
                ctrl: {},
                model: {},
                profile: {},
                group: {},
                role: opt.role
            });
        },

        renderTemplate: function(groupId) {
            this.showTemplatePage(groupId);
        },

        showTemplateAssignmentPanel: function(groupId, userId, dayId) {
            var model = this.model,
                assignment = model.assignment || (model.assignment = new MTemplateAssignment()),
                view = this.view.assigment,
                content = this.getLayout().getContent();

            if (!view) {
                view = this.view.assigment = new VTemplateAssignmentPanel({
                    profile: this.profile,
                    url: this.url.template,
                    group: this.group,
                    model: assignment,
                });
                this.listenTo(view, 'back', this.onBack);
            }

            this.when(
                content.toggleInfoOverlay(false)
            ).then(function() {
                assignment.setStartDate(dayId);
                content.setInfoContent(view, { open: true });
            });

            return this;
        },

        showTemplatePage: function(groupId, templateId) {
            this.collection = this.collection || (this.collection = new CTemplateAssignments());

            this.view.edit = this.view.edit || (this.view.edit = new VTemplate({
                model: this.model.template || (this.model.template = new MTemplate()),
                collection: this.collection,
                profile: User,
                url: this.url.template,
                group: this.getLayout().getGroup(),
                role: this.role
            }));

            this.when(
                this.getLayout().setGroupId(groupId),
                this.model.template.setId(templateId),
                this.collection.setTemplate(templateId),
                User.fetch(),
                Supervisors.fetch(),
                this.isNewTemplate() ? this.model.template.reset({ group: this.group.id }) : this.model.template.fetch()
            ).then(function() {
                this.getLayout().getContent().setView(this.view.edit, true);
                this.view.edit.resetModel();
            });

            return this;

        },

        showTemplatePageWithAssignmentPanel: function(groupId, templateId) {

            var model = this.model;
            var template = model.template || (model.template = new MTemplate());

            var collection = this.collection || (this.collection = new CTemplateAssignments()),
                layout = this.getLayout(),
                view = this.view.edit || (this.view.edit = new VTemplate({
                    model: template,
                    collection: collection,
                    profile: User,
                    url: this.url.template,
                    group: layout.getGroup(),
                    role: this.role
                }));

            this.when(
                layout.setGroupId(groupId),
                template.setId(templateId),
                collection.setTemplate(templateId),
                User.fetch(),
                Supervisors.fetch(),
                collection.getFirstPage(),
                this.isNewTemplate() ? template.reset({ group: this.group.id }) : template.fetch()
            ).then(function() {
                layout.getContent().setView(view, true);
                view.view.content.onManageAssignments();
            });

            return this;

        },

        showAssignmentManagerPanel: function(groupId, userId, dayId) {
            var view = this.view.manager,
                collection = this.collection || (this.collection = new CTemplateAssignments()),
                layout = this.getLayout(),
                content = layout.getContent();

            if (!view) {
                view = this.view.manager = new VPerUserAssignmentManagerPanel({
                    profile: this.profile,
                    url: this.url,
                    group: this.group,
                    collection: collection,
                });
                this.listenTo(view, 'back', this.onBack);
            }

            this.when(
                layout.setMemberId(userId),
                collection.setUser(this.profile.id),
                collection.getFirstPage()
            ).then(function() {
                content.setInfoContent(view, { open: true });
            });

            return this;
        },

        isNewTemplate: function() {
            var id = this.model.template.id;
            return id === 'new' || !id;
        },

        ////////////
        // routes //
        ////////////

        index: function(groupId) {
            this.renderTemplate(groupId);
        },


        assignmentRoute: function(groupId, templateId) {
            this.showTemplatePageWithAssignmentPanel(groupId, templateId);
        },


        editRoute: function(groupId, templateId) {
            this.showTemplatePage(groupId, templateId);
        },

        assignRoute: function(groupId, userId, dayId) {
            this.showTemplateAssignmentPanel(groupId, userId, dayId);
        },

        manageRoute: function(groupId, userId, dayId) {
            this.showAssignmentManagerPanel(groupId, userId, dayId);
        },

        ////////////
        // events //
        ////////////

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },

        onBack: function() {
            this.trigger('back');
        },

    });

    return TemplateCtrl;
});

